import React from 'react';
import HorecaLayout from './HorecaLayout';
import HerocaHomeBanner from './components/horeca/herocahomebanner';
import HorecaOffering from './components/horeca/herocaofferig';
import HorecaAbout from './components/horeca/horecaabout';
import Sustainablility from './components/horeca/sustainability';
import HorecaFeaturedProducts from './components/horeca/horecafeaturedproducts';


const HorecaHome = () => {


    return(<>
    <HorecaLayout >
     <HerocaHomeBanner/>
     <HorecaOffering/>
     <HorecaAbout/>
     <Sustainablility/>
     <HorecaFeaturedProducts/>
     
    

    </HorecaLayout >
    </>);


}

export default HorecaHome;